import React from 'react'
import Transition from '../components/transition'

const Wrapper = ({ children, location }) => (
  <Transition location={location}>{children}</Transition>
)

export default Wrapper
